module.exports = __webpack_public_path__ + "d3bd325afceb444dfe8fd032d76245f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/gifts/gift-card-bg-with-logo.jpg
// module id = 1745
// module chunks = 9 15 47